import React from 'react';

import PdpIcon from '../product/pdpIcon';
import NewsletterForm, { UNSUBSCRIBE_NOTE } from './newsletterForm';
import useNewsletterSignup from './useNewsletterSignup';

// Press Sheet signup on /newsletter. Styles: styles/_newsletter-archive.scss (nla- prefix).
const SubscribeForm = () => {
  const signup = useNewsletterSignup();

  if (!signup.subscribedEmail) {
    return (
      <div className="nla-subscribe">
        <NewsletterForm signup={signup} tone="light" />
      </div>
    );
  }

  // "Press Sheet Archive — Subscribed state" in design/website.pen.
  return (
    <div className="nla-subscribe">
      <div className="nla-subscribed" role="status">
        <span className="nla-subscribed-badge">
          <PdpIcon name="check" size={16} />
        </span>
        <span className="nla-subscribed-text">
          <strong>Thank you for subscribing.</strong>
          <span>The next roll will land at {signup.subscribedEmail}.</span>
        </span>
      </div>
      <p className="nla-subscribed-note">{UNSUBSCRIBE_NOTE}</p>
    </div>
  );
};

export default SubscribeForm;
